// extracted by mini-css-extract-plugin
export default {"label":"SelectType_label__l4Vm8","select":"SelectType_select__1Lzmn","selectError":"SelectType_selectError__Ff6Bc"};